import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import BoxShadow from "%/dynamic-component-editor/options/box-shadow";
import TextShadow from "%/dynamic-component-editor/options/text-shadow";

export default class EffectsOptions extends BaseOptionsBundle {
  optionTitle = "Effects";
  static optionClassName = "i-dynamic-effects";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new BoxShadow(undefined, hideFromInspector["box-shadow"] ?? false),
      new TextShadow(undefined, hideFromInspector["text-shadow"] ?? false),
    ]);
  }
}
